<template>
  <ux-form
    ref="form"
    :data="formData"
    width="480px"
    :colon="true"
    :rules="rules"
    label-width="56px"
  >
    <ux-form-item :label="$t('HT.apiList.group')" prop="groupId">{{ data.name }}</ux-form-item>
    <ux-form-item :label="$t('HT.debug3.domain')" prop="domain">
      <ux-input
        v-model="formData.domain"
        :placeholder="$t('HT.domain.placeholder')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addAccessApi.evn')" prop="envs">
      <ux-checkbox v-model="formData.envs" :options="$opt.env2"></ux-checkbox>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      formData: {
        id: this.data.id, // 分组id
        domain: '', // 域名
        envs: [] // 环境
      },
      rules: this.$rul.bindDomain()
    };
  }
};
</script>

<style lang="scss" scoped></style>
